import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetAllDiarioObrasEquipamentoUseCase } from "../../../presentation/useCases/read/get_all_diario_obras_equipamento_use_case";
import { DiarioObrasEquipamentoFilter } from "../../models/diario_obras_equipamento_filter";
import { DiarioObrasEquipamentoLista } from "../../models/diario_obras_equipamento_lista";
import { IDiarioObraRepository } from "../../repositories/diario_obra_repository";


// GetAllDiarioObrasEquipamentoServicoUseCase


export class GetAllDiarioObrasEquipamentoServicoUseCase
  extends BasePaginatedUseCase<DiarioObrasEquipamentoLista>
  implements IGetAllDiarioObrasEquipamentoUseCase {
  constructor(private readonly repository: IDiarioObraRepository) {
    super();
  }

  async getAllListagemDiariosObrasEquipamento(
    filter: DiarioObrasEquipamentoFilter,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    if (filter.IdDiarioObras === undefined) throw new Error('Id de diario de obra inválido!');

    const response = await this.repository
      .getAllListagemDiariosObrasEquipamento(
        filter,
        page,
        rowsPerPage,
      );
    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
